import { render, staticRenderFns } from "./ExistingPropertySharedPercentage.vue?vue&type=template&id=1ae71703"
import script from "./ExistingPropertySharedPercentage.vue?vue&type=script&lang=js"
export * from "./ExistingPropertySharedPercentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports